import { GetMyUserDocument } from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { until } from '@vueuse/core';
import { computed } from 'vue';

export async function waitForUser(currentUser: ReturnType<typeof useMyUser>['currentUser']) {
    await until(currentUser).toMatch((u) => !!u?.id, {
        timeout: 5000,
        throwOnTimeout: true,
    });
}

function setEmptyUser() {
    return {
        id: '',
        name: '',
        firstName: '',
        lastName: '',
        icon: undefined,
        userPasswordLogin: {
            id: '',
            email: '',
        },
    };
}

export function useMyUser() {
    const { result, loading, error } = useQuery(
        GetMyUserDocument,
        {},
        {
            fetchPolicy: 'cache-first',
        },
    );

    const currentUser = computed(() => result.value?.myUser ?? setEmptyUser());
    const currentUserId = computed(() => currentUser.value?.id ?? '');
    const currentUserName = computed(() => currentUser.value?.name ?? '');
    const isUserReady = computed(() => !loading.value && !!currentUser.value.id);

    return {
        currentUser,
        currentUserId,
        currentUserName,
        isUserReady,
        loading,
        error,
    };
}
